import React from 'react';
import FigoLottie from './FigoLottie';
import InputErrorLabel from './InputErrorLabel';
import './ForgetPasswordInput.css';

const ForgetPasswordInput = (props) => {
  function handleOnChange(event) {
    if (props.onChange) {
      props.onChange(event);
    }
  }

  function handleOnBlur() {
    if (props.onBlur) {
      props.onBlur();
    }
  }

  function handleOnKeyPress(event) {
    if (props.onKeyPress) {
      props.onKeyPress(event);
    }
  }

  function renderLoading() {
    if (props.loading) {
      return (
        <div className="Forget-password-input-spinner">
          <FigoLottie height={25} width={25} />
        </div>
      );
    }

    return null;
  }

  return (
    <div
      className={`Forget-password-input-container ${props.className || ''} ${
        props.paddingRight ? 'Forget-password-input-padding-right' : ''}`}
    >
      <span className="Forget-password-input-title">{props.title}</span>

      <input
        autoComplete={props.autoComplete}
        className={`Forget-password-input
          ${props.error && ' Forget-password-input-error'}`}
        disabled={props.disabled}
        maxLength={props.maxLength || 30}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        onKeyPress={handleOnKeyPress}
        placeholder={props.placeholder || ''}
        value={props.value}
      />

      <InputErrorLabel error={props.error} />

      {renderLoading()}
    </div>
  );
};

export default ForgetPasswordInput;
